import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz18 = () => {
    return (
        <div>
               <NavLink to='/category/Puzzels/Puzzel19'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel17'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Torch and Bridge</h1>
   
    <div class="text">
        <p><strong><u>Puzzle</u>:</strong> There are 4 persons (A, B, C and D) who want to cross a bridge in night.</p>
        <ol>
            <li>A takes 1 minute to cross the bridge.</li>
            <li>B takes 2 minutes to cross the bridge.<p></p>
            </li>
            <li>C takes 5 minutes to cross the bridge.</li>
            <li>D takes 8 minutes to cross the bridge.</li>
        </ol>
        <p>There is only one torch with them and the bridge cannot be crossed without the torch. There cannot be more
            than two persons on the bridge at any time, and when two people cross the bridge together, they must move at
            the slower person’s pace.<br/></p>
        <p>Can they all cross the bridge in 15 minutes?</p>
        <p>&nbsp;<br/>&nbsp;<br/>&nbsp;<br/>&nbsp;</p><br/>
        <div class="containers">
        <p><strong><u>Solution</u>:</strong> They must cross the bridge in the following way:</p>
        <ol>
            <li><strong>Step 1:</strong> A and B cross the bridge. A comes back. Time taken <strong>3 minutes</strong>.
                Now B is on the other side.<br/></li>
            <li><strong>Step 2:</strong> C and D cross the bridge. B comes back. Time taken <strong>8 + 2 = 10
                    minutes</strong>. Now C and D are on the other side.<br/></li>
            <li><strong>Step 3:</strong> A and B cross the bridge. Time taken is <strong>2 minutes</strong>. All are on
                the other side.<br/></li>
        </ol>
        <p><strong>Total time spent:</strong> 3 + 10 + 2 = 15 minutes.</p>
      </div>
    </div>
</article>
        </div>
    )
}

export default Puz18
